export default __webpack_public_path__ + "static/social media 1-12e337adb87533be0394eb0d628b51c9.webp";